import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { Button } from '@mui/material';

import { SECTION } from 'src/constants/section';
import { routePaths } from 'src/services/routing/routePaths';
import { useUserContext } from 'src/components/app/context/UserContext';

import { styles } from './BackButton.styles';

const BackButton = () => {
  const { t, i18n } = useTranslation('survey');
  const { setSurvey, previousSurvey } = useUserContext();
  const history = useHistory();

  const prevSectionName = useMemo(() => {
    const historyState = history.location.state as { fromSection?: number };
    const prevSection = historyState?.fromSection;
    return prevSection
      ? t(`navigation:sectionName.${SECTION[prevSection]}`)
      : null;
  }, [history.location.state, i18n.language]);

  const onClick = () => {
    if (!previousSurvey) return;

    setSurvey(previousSurvey);
    history.push(routePaths.START);
  };

  return (
    <Button
      sx={styles.backToDashboard}
      // Send the user back to the start page, which will use the session to
      //  determine which page to show.
      onClick={onClick}
      startIcon={<ArrowBackRounded />}
      variant="cta"
      color="tertiary"
    >
      {prevSectionName
        ? t('common:backTo', { section: prevSectionName })
        : t('common:back')}
    </Button>
  );
};

export default BackButton;
